import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { map, Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { BookingMapper } from "@app/core/booking/data/network/booking.mapper";
import { Booking } from "@app/core/booking/domain/model/booking";
import { PaymentMethodType } from "@app/core/shared/domain/payment-method-type";
import { PaymentMethodWSMapper } from "./payment-method-ws.mapper";

@Injectable({ providedIn: "root" })
export class ApplyBookingPaymentWS {
  private readonly paymentMethodWSMapper = new PaymentMethodWSMapper();
  constructor(private baseHandler: BaseHandler) {}

  execute(
    bookingId: string,
    paymentType: string,
    paymentMethodType: PaymentMethodType,
    token: string
  ): Observable<Booking> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.APPLY_BOOKING_PAYMENT_ENDPOINT(bookingId))
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        payment_type: paymentType,
        payment_method:
          this.paymentMethodWSMapper.deserialize(paymentMethodType),
      })
      .build();
    return this.baseHandler.execute(parameters).pipe(
      map((response) => {
        return BookingMapper.deserialize(response);
      })
    );
  }
}
